export default __webpack_public_path__ + "static/media/phone-ic.52141fcc.svg";